import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import axios from 'axios'
import ReactPaginate from 'react-paginate';
import { BASEURL } from "../Config"
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { getBookInfo } from '../modules/actions';
import { connect } from "react-redux";
import swal from "sweetalert";

class Books extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            offset: 0,
            slice: [],
            perPage: 5,
            currentPage: 0,
            editableRow: null,
            name: "",
            classno: 0,
            subject: "",
            id: "",
            subjects: [],
            searchTerm: '',
            searchData: [],
            dataSearched: false,
            noResults: false
        }
        this.handlePageClick = this
            .handlePageClick
            .bind(this);
    }

    receivedData() {
        axios
            .get(`${BASEURL}/api/v1/books/fetchall`)
            .then(res => {
                console.log('res.data', res.data);
                let data = this.state.data;
                data = [];
                for (let i = 0; i < res.data.length; i++) {
                    if (!res.data[i].isDeleted) {
                        data.push(res.data[i]);
                    }
                }
                // console.log('data', data);
                const slice = data.slice(this.state.offset, this.state.offset + this.state.perPage)
                console.log('slice', slice);
                this.setState({
                    data,
                    pageCount: Math.ceil(data.length / this.state.perPage),
                    slice
                })
            });
    }

    sliceData() {
        let data = this.state.data;
        let slice;
        let pageCount;
        if (this.state.dataSearched && this.state.searchData.length > 0) {
            slice = this.state.searchData.slice(this.state.offset, this.state.offset + this.state.perPage)
            pageCount = Math.ceil(this.state.searchData.length / this.state.perPage)
        } else {
            slice = data.slice(this.state.offset, this.state.offset + this.state.perPage)
            pageCount = Math.ceil(data.length / this.state.perPage)
        }
        console.log('slice', slice);


        this.setState({
            pageCount,
            slice
        })
    }

    handlePageClick(e) {
        const selectedPage = e.selected;
        const offset = selectedPage * this.state.perPage;
        this.setState({
            currentPage: selectedPage,
            offset: offset
        }, () => {
            this.sliceData()
        });
    };

    handleAddChapters = (bid) => {
        this.props.dispatch(getBookInfo(bid));
        this.props.history.push({
            pathname: '/addChapters',
            state: { bid: bid }
        });
    }

    handleViewChapters = (bid) => {
        this.props.dispatch(getBookInfo(bid));
        this.props.history.push({
            pathname: '/chapters',
            state: { bid: bid }
        });
    }

    componentDidMount() {
        axios
            .get(`${BASEURL}/api/v1/subjects/fetchall`)
            .then(res => {
                console.log('res.data', res.data);
                let subjects = this.state.subjects;
                for (let i = 0; i < res.data.length; i++) {
                    subjects.push(res.data[i].subject);
                }
                this.setState({
                    subjects
                })
            });
        this.receivedData()
    }

    handleSearch() {
        const { searchTerm, data } = this.state;
        let searchData = [];
        if (searchTerm !== '') {
            const ids = new Set();
            searchData = data.filter(item => {
                const isMatch = item.name.toLowerCase().includes(searchTerm.toLowerCase());
                if (isMatch && !ids.has(item._id)) {
                    ids.add(item._id);
                    return true;
                }
                return false;
            });
        }

        if (searchData.length > 0) {
            const { perPage } = this.state;
            const slice = searchData.slice(0, perPage);
            const pageCount = Math.ceil(searchData.length / perPage);
            this.setState({
                dataSearched: true,
                slice,
                pageCount,
                searchData,
                currentPage: 0,
                noResults: false
            });
        } else {
            this.setState({
                dataSearched: false,
                currentPage: 0,
                pageCount: 0
            });

            if (searchTerm !== '') {
                this.setState({
                    noResults: true
                })
            } else {
                this.handleShowAllBooks()
            }
        }
    }

    handleShowAllBooks() {
        // window.location = "books"
        const { data } = this.state;
        const slice = data.slice(0, this.state.perPage)
        // console.log('slice', slice);
        this.setState({
            pageCount: Math.ceil(data.length / this.state.perPage),
            slice,
            searchTerm: '',
            noResults: false
        })
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleUpdateBook() {
        let data = {};
        data.id = this.state.id;
        data.name = this.state.name;
        data.classno = this.state.classno;
        data.subject = this.state.subject;

        // console.log('this.state.id', this.state.id)

        // console.log('update data', data)
        axios.put(`${BASEURL}/api/v1/books/update`, data)
            .then(res => {
                if (res.status === 200) {
                    console.log('res.data', res.data);
                    this.receivedData()
                }
            })
            .catch((err) => {
                console.log('Update book Error', err);
            })
    }

    handleOnDeleteBook(id) {
        swal({
            title: "Are you sure?",
            text: "All the chapters, topics and questions related to this book will be deleted!",
            icon: "warning",
            buttons: [
                'No',
                'Yes'
            ],
            dangerMode: true,
        }).then(function (isConfirm) {
            if (isConfirm) {
                let obj = {};
                obj.id = id;
                obj.isDeleted = true;
                console.log('obj');
                axios.post(`${BASEURL}/api/v1/books/updateDeleteStatus`, obj)
                    .then(res => {
                        if (res.status === 200) {
                            swal('Success', 'Book Deleted Successfully', 'success')
                                .then(function () {
                                    window.location = "books";
                                })
                        } else {
                            swal('Error', 'Error in deleting the book', 'error')
                                .then(function () {
                                    window.location = "books";
                                })
                        }
                    })
            }
        });
    }

    render() {
        return (

            <div id="wrapper">
                <Sidebar act="books" />
                {/* Content Wrapper */}
                <div className="content-page">
                    {/* Main Content */}
                    <div className="content">
                        <Topbar act="Books" breadcrumbItems={['Test Generator', 'Books']} />
                        {/* container */}
                        {/* content */}
                        <div className="container-fluid main-container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card main-card">
                                        <div className="card-body">
                                            <NavLink to='/addBooks' className="btn  btn-new"><i className="mdi mdi-plus-circle" /> Add Books</NavLink>
                                            <form onSubmit={(e) => {
                                                e.preventDefault(); // Prevent default form submission
                                                this.handleSearch();
                                            }}>
                                                <div className="d-flex mt-2">
                                                    <div className="col-md-6 marginRight">
                                                        <input type="text" id="searchbookname" className="form-control"
                                                            onChange={(e) => this.setState({ searchTerm: e.target.value })}
                                                            placeholder="Search Book Name"
                                                            value={this.state.searchTerm} />
                                                    </div>
                                                    <button className="btn btn-new marginRight" type="submit">Search</button>
                                                    <button className="btn btn-new" onClick={() => this.handleShowAllBooks()}>Show all books</button>
                                                </div>
                                            </form>
                                            {/* {this.state.noResults ? <p>No results found</p> : ''} */}
                                            <table className="table table-centered mb-0 mt-2">
                                                <thead>
                                                    <tr>
                                                        <th>Name of the book</th>
                                                        <th>Class</th>
                                                        <th>Subject</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                {this.state.noResults ?
                                                    <tbody>
                                                        <tr className="text-center">
                                                            <td colSpan={4}>
                                                                No Results Found
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    :
                                                    <tbody>
                                                        {this.state.slice.map((data, idx) => (
                                                            <tr>
                                                                <td className="table-user" width={'28%'}>
                                                                    {this.state.editableRow === idx ?
                                                                        <input type="text" id="bookname" className="form-control" onChange={(e) => this.handleChange(e, data._id)}
                                                                            name="name" placeholder="Enter Book Name"
                                                                            defaultValue={data.name} disabled={this.state.editableRow !== idx} />
                                                                        :
                                                                        <input type="text" id="bookname" className="form-control" onChange={(e) => this.handleChange(e, data._id)}
                                                                            name="name" placeholder="Enter Book Name"
                                                                            value={data.name} disabled={this.state.editableRow !== idx} />
                                                                    }
                                                                </td>
                                                                <td className="table-user" width={'15%'}>
                                                                    {this.state.editableRow === idx ?
                                                                        <select className="form-select"
                                                                            onChange={(e) => this.handleChange(e, data._id)}
                                                                            name="classno" defaultValue={data.classno} disabled={this.state.editableRow !== idx}>
                                                                            <option value="0">Select class</option>
                                                                            <option value="Nursery">Nursery</option>
                                                                            <option value="LKG">LKG</option>
                                                                            <option value="UKG"> UKG</option>
                                                                            <option value="1">Class 1</option>
                                                                            <option value="2">Class 2</option>
                                                                            <option value="3">Class 3</option>
                                                                            <option value="4">Class 4</option>
                                                                            <option value="5">Class 5</option>
                                                                            <option value="6">Class 6</option>
                                                                            <option value="7">Class 7</option>
                                                                            <option value="8">Class 8</option>
                                                                            <option value="9">Class 9</option>
                                                                            <option value="10">Class 10</option>
                                                                            <option value="11">Class 11</option>
                                                                            <option value="12">Class 12</option>
                                                                        </select> :
                                                                        <select className="form-select"
                                                                            onChange={(e) => this.handleChange(e, data._id)}
                                                                            name="classno" value={data.classno} disabled={this.state.editableRow !== idx}>
                                                                            <option value="0">Select class</option>
                                                                            <option value="Nursery">Nursery</option>
                                                                            <option value="LKG">LKG</option>
                                                                            <option value="UKG"> UKG</option>
                                                                            <option value="1">Class 1</option>
                                                                            <option value="2">Class 2</option>
                                                                            <option value="3">Class 3</option>
                                                                            <option value="4">Class 4</option>
                                                                            <option value="5">Class 5</option>
                                                                            <option value="6">Class 6</option>
                                                                            <option value="7">Class 7</option>
                                                                            <option value="8">Class 8</option>
                                                                            <option value="9">Class 9</option>
                                                                            <option value="10">Class 10</option>
                                                                            <option value="11">Class 11</option>
                                                                            <option value="12">Class 12</option>
                                                                        </select>
                                                                    }
                                                                </td>
                                                                <td className="table-user" width={'15%'}>
                                                                    {this.state.editableRow === idx ?
                                                                        <select className="form-select"
                                                                            onChange={(e) => this.handleChange(e, data._id)}
                                                                            name="subject" defaultValue={data.subject} disabled={this.state.editableRow !== idx}>
                                                                            <option value="0">Select Subject</option>
                                                                            {this.state.subjects.map((subject, idx) =>
                                                                                <option value={subject}>{subject}</option>
                                                                            )}
                                                                        </select>
                                                                        :
                                                                        <select className="form-select"
                                                                            onChange={(e) => this.handleChange(e, data._id)}
                                                                            name="subject" value={data.subject} disabled={this.state.editableRow !== idx}>
                                                                            <option value="0">Select Subject</option>
                                                                            {this.state.subjects.map((subject, idx) =>
                                                                                <option value={subject}>{subject}</option>
                                                                            )}
                                                                        </select>
                                                                    }
                                                                </td>
                                                                <td >
                                                                    {/* {this.state.editableRow === idx ?
                                                                    <button className="btn btn-primary brn-sm table_Action_btns"
                                                                        onClick={() => { this.handleUpdateBook(); this.setState({ editableRow: null }); }}>
                                                                        <i className="mdi mdi-content-save-outline" />save</button> :
                                                                    <button className="btn mb-2"
                                                                        onClick={() => { this.setState({ editableRow: idx, id: data._id, name: data.name, classno: data.classno, subject: data.subject }) }}>
                                                                        <i className="mdi mdi-pencil" /></button>
                                                                } */}
                                                                    <button className="btn mb-2"
                                                                        onClick={() => { this.props.history.push('/editBook/' + data._id) }}>
                                                                        <i className="mdi mdi-pencil" />
                                                                    </button>
                                                                    <button className="btn mb-2" onClick={() => this.handleOnDeleteBook(data._id)}> <i className="mdi mdi-delete" /></button>
                                                                    <button className="btn btn-success brn-sm table_Action_btns mb-2"
                                                                        onClick={() => this.handleAddChapters(data._id)}
                                                                    > <i className="mdi mdi-plus-circle" /> Chapters</button>
                                                                    <button className="btn btn-warning brn-sm mb-2"
                                                                        onClick={() => this.handleViewChapters(data._id)}
                                                                    > <i className="mdi mdi-eye-circle" /> Chapters</button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                }
                                            </table>

                                            <div className="pagination-div">
                                                <ReactPaginate
                                                    previousLabel={"Previous"}
                                                    nextLabel={"Next"}
                                                    breakLabel={"..."}
                                                    breakClassName={"break-me"}
                                                    pageCount={this.state.pageCount}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={5}
                                                    onPageChange={this.handlePageClick}
                                                    forcePage={this.state.currentPage}
                                                    containerClassName={"pagination"}
                                                    subContainerClassName={"pages pagination"}
                                                    activeClassName={"active"} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* End of Main Content */}
                        <Footer />
                    </div>
                    {/* End of Content Wrapper */}
                </div>

            </div>
        )
    }
}


// const mapDispatchToProps = dispatch => ({
//     getBook: (bid) => dispatch(getBookInfo(bid)),
// });

export default connect()(Books);